import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
/* eslint no-magic-numbers: "off" */

import random from 'math-random';
export default function useCSSKey() {
  return random().toString(26).substr(2, 5).replace(/[0-9]/g, function (value) {
    return String.fromCharCode(value.charCodeAt(0) + 65);
  });
}